import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getDisabledSectionStyles = (theme: Theme): SerializedStyles =>
    css({
        background: theme.palette.gray[100],
        border: 'none',
        padding: theme.spacing(2),
        opacity: 0.7,
        'div:last-of-type': {
            marginBottom: 0,
        },
    });

export const getListContainerStyles = (theme: Theme): SerializedStyles =>
    css({
        marginTop: theme.spacing(4),
    });

export const getSpinnerStyles = (theme: Theme): SerializedStyles =>
    css({
        padding: theme.spacing(6),
        width: '100%',
    });
